import { Vector3 } from 'three';

import { LinkEndResultVisualProps } from '../../three/analysis/LinkEndResultVisual';
import { poundToInchScalar } from '../unitScalarsForVisuals';

const convertForceToVector = (linkForceData: LinkEndResultVisualProps) =>
  new Vector3(linkForceData.globalForceVector.x, linkForceData.globalForceVector.y, 0).multiplyScalar(
    poundToInchScalar,
  );

export default convertForceToVector;
